'use strict';

DoohApps.filter('DataType', function () {
    return function (type) {
        switch (type) {
            case 'Screen':
                return '"';
            default:
                return;
        }
    }
});